var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#784DB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11929 3.9262L5.25902 7.78653C5.16982 7.87574 5.12085 7.99467 5.12085 8.12425C5.12085 8.25122 5.16982 8.37023 5.25902 8.45929L9.11562 12.316C9.2049 12.4052 9.3239 12.4543 9.45087 12.4543C9.57784 12.4543 9.69692 12.4053 9.78613 12.316L10.0702 12.032C10.1594 11.9428 10.2086 11.8237 10.2086 11.6968C10.2086 11.5698 10.1594 11.4508 10.0702 11.3615L6.83157 8.12291L10.0739 4.88073C10.163 4.79153 10.2122 4.67252 10.2122 4.54548C10.2122 4.41851 10.163 4.29957 10.0739 4.2103L9.78972 3.9262C9.6049 3.74145 9.3041 3.74145 9.11929 3.9262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleArrowLeft);
export default __webpack_public_path__ + "static/media/purple-arrow-left.1c2d7335915af25d4012402bee37d0a6.svg";
export { ForwardRef as ReactComponent };